import axios from '@/lib/axios';
import { PurchaseOrderContractTask, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0790. 発注案件契約タスク登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  contract_context_id: number;
  name: string;
  description?: string;
  due_date?: string;
};

const createPurchaseOrderContractTask = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks`,
    props
  );
};

export const useCreatePurchaseOrderContractTask = () => {
  return useMutation({
    mutationFn: createPurchaseOrderContractTask,
  });
};
